import { OpeningTextWidgetState } from '../../models/OpeningTextWidgetState';
import { useLangaugeContent } from './hooks/useLanguageContent';

export const OpeningTextCard = ({ props }: { props: OpeningTextWidgetState }) => {
  const { truncatedTitle, truncatedDescription } = useLangaugeContent({ props });

  if (!props.image) return <></>;

  return (
    <div
      className={`shadow-md rounded min-[350px]:w-[75%] min-[350px]:mx-auto sm:mx-0 min-[350px]:min-h-[100px] sm:w-[478px] min-[350px]:p-3 min-[768px]:p-4 min-[1024px]:p-5 z-2 min-[350px]:relative min-[350px]:-mt-12 sm:mt-0 sm:absolute min-[350px]:ml-0 min-[350px]:mr-0 ${
        props.aligment === 'left' ? 'sm:ml-[28px]' : 'sm:mr-[28px]'
      }`}
      style={{ background: props.cardColor ? props.cardColor : 'white', height: '50%' }}
    >
      <h1 className=' font-body font-bold min-[350px]:text-[18px] sm:text-[26px]' style={{ color: props.textColor }}>
        {truncatedTitle}
      </h1>
      {truncatedTitle !== '' && <div className='w-[100px] my-2 h-[3px] ' style={{ background: props.dividerColor }} />}
      <p className='font-sans font-normal min-[350px]:text-[14px] sm:text-[18px] ' style={{ color: props.textColor }}>
        {truncatedDescription}
      </p>
    </div>
  );
};
